import React, { useMemo, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import { useDataStore } from '../context/DataStoreContext';
export function Reportes() {
  const [activeTab, setActiveTab] = useState('funnel');
  const {
    leads
  } = useDataStore();
  const funnelData = useMemo(() => {
    const total = leads.length;
    const contactados = leads.filter(l => l.STATE !== 'Nuevo').length;
    const conversacion = leads.filter(l => ['Conversación', 'Micro-acuerdo', 'EnviadoPropuesta', 'LeadCualificado', 'Onboarding', 'Entregado'].includes(l.STATE)).length;
    const microAcuerdo = leads.filter(l => ['Micro-acuerdo', 'EnviadoPropuesta', 'LeadCualificado', 'Onboarding', 'Entregado'].includes(l.STATE)).length;
    const propuesta = leads.filter(l => ['EnviadoPropuesta', 'LeadCualificado', 'Onboarding', 'Entregado'].includes(l.STATE)).length;
    const cualificado = leads.filter(l => ['LeadCualificado', 'Onboarding', 'Entregado'].includes(l.STATE)).length;
    return [{
      name: 'Nuevos',
      value: total,
      color: '#4A4A4A'
    }, {
      name: 'Contactados',
      value: contactados,
      color: '#757575'
    }, {
      name: 'Conversación',
      value: conversacion,
      color: '#9E9E9E'
    }, {
      name: 'Micro-acuerdo',
      value: microAcuerdo,
      color: '#E6E6E6'
    }, {
      name: 'Propuesta',
      value: propuesta,
      color: '#FFFFFF'
    }, {
      name: 'Cualificado',
      value: cualificado,
      color: '#27AE60'
    }];
  }, [leads]);
  const metrics = useMemo(() => {
    const total = leads.length || 1; // prevent div by 0
    const contactados = funnelData[1].value;
    const conversacion = funnelData[2].value;
    const propuesta = funnelData[4].value;
    const cualificado = funnelData[5].value;
    return {
      tasaContacto: (contactados / total * 100).toFixed(1),
      tasaRespuesta: contactados > 0 ? (conversacion / contactados * 100).toFixed(1) : '0.0',
      convPropuesta: conversacion > 0 ? (propuesta / conversacion * 100).toFixed(1) : '0.0',
      convFinal: (cualificado / total * 100).toFixed(1)
    };
  }, [funnelData, leads.length]);
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-1085">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1086">
        <div data-id="element-1087">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-1088">Reportes</h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-1089">
            Análisis de conversión y rendimiento.
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-1090">
          <button className="btn-secondary inline-flex items-center" data-id="element-1091">
            <FileSpreadsheet className="w-4 h-4 mr-2" data-id="element-1092" /> CSV
          </button>
          <button className="btn-secondary inline-flex items-center" data-id="element-1093">
            <FileText className="w-4 h-4 mr-2" data-id="element-1094" /> PDF
          </button>
        </div>
      </div>

      <div className="border-b border-white/5" data-id="element-1095">
        <nav className="-mb-px flex space-x-8 overflow-x-auto hide-scrollbar" data-id="element-1096">
          {['Daily Setter', 'Territory Weekly', 'QA', 'Funnel'].map(tab => {
          const id = tab.toLowerCase().replace(' ', '-');
          return <button key={id} onClick={() => setActiveTab(id)} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-[13px] transition-colors ${activeTab === id ? 'border-growthly-green text-growthly-text' : 'border-transparent text-growthly-muted hover:text-growthly-text hover:border-white/20'}`} data-id="element-1097">
                {tab}
              </button>;
        })}
        </nav>
      </div>

      {activeTab === 'funnel' && <div className="card p-6" data-id="element-1098">
          <h3 className="text-[18px] font-semibold text-growthly-text mb-6" data-id="element-1099">
            Funnel de Conversión Global
          </h3>

          {leads.length === 0 ? <div className="h-[400px] w-full flex items-center justify-center text-growthly-muted text-[13px] border border-dashed border-white/10 rounded-lg" data-id="element-1100">
              Añade leads para visualizar el funnel
            </div> : <div className="h-[400px] w-full" data-id="element-1101">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1102">
                <BarChart data={funnelData} layout="vertical" margin={{
            top: 20,
            right: 30,
            left: 40,
            bottom: 5
          }} data-id="element-1103">
                  <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="rgba(255,255,255,0.06)" data-id="element-1104" />
                  <XAxis type="number" hide data-id="element-1105" />
                  <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
              fontSize: 12,
              fill: '#BDBDBD'
            }} data-id="element-1106" />
                  <Tooltip cursor={{
              fill: 'rgba(255,255,255,0.05)'
            }} contentStyle={{
              backgroundColor: '#1F1F1F',
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#FFFFFF'
            }} itemStyle={{
              color: '#FFFFFF'
            }} formatter={(value: number) => [`${value} leads`, 'Volumen']} data-id="element-1107" />
                  <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={32} label={{
              position: 'right',
              fill: '#FFFFFF',
              fontSize: 12,
              fontWeight: 600
            }} data-id="element-1108">
                    {funnelData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1109" />)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>}

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 pt-6 border-t border-white/5" data-id="element-1110">
            <div data-id="element-1111">
              <p className="text-[12px] text-growthly-muted" data-id="element-1112">Tasa Contacto</p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-1113">
                {metrics.tasaContacto}%
              </p>
            </div>
            <div data-id="element-1114">
              <p className="text-[12px] text-growthly-muted" data-id="element-1115">Tasa Respuesta</p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-1116">
                {metrics.tasaRespuesta}%
              </p>
            </div>
            <div data-id="element-1117">
              <p className="text-[12px] text-growthly-muted" data-id="element-1118">
                Conv. a Propuesta
              </p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-1119">
                {metrics.convPropuesta}%
              </p>
            </div>
            <div data-id="element-1120">
              <p className="text-[12px] text-growthly-muted" data-id="element-1121">
                Conv. Final (Cualificado)
              </p>
              <p className="text-[22px] font-bold text-growthly-green" data-id="element-1122">
                {metrics.convFinal}%
              </p>
            </div>
          </div>
        </div>}

      {activeTab !== 'funnel' && <div className="bg-growthly-surface/50 border border-white/10 border-dashed rounded-lg p-12 text-center" data-id="element-1123">
          <p className="text-growthly-muted" data-id="element-1124">
            Selecciona la pestaña Funnel para ver el gráfico principal.
          </p>
        </div>}
    </div>;
}